<template>
    <div>
        <ais-instant-search
            :search-client="searchClient"
            :index-name="index"
            :routing="routing"
        >
            <ais-configure
                :filters="searchFilters"
            />

            <!-- Filters -->
            <filter-panel-mobile :filters="categoryFilters"/>

            <div class="row">
                <filter-panel
                    :filters="categoryFilters"
                    class="col-12 col-md-4 col-lg-3 algolia-listing-filters d-none d-md-block"
                />
                <algolia-search-results
                    page-type="Category"
                    :lang-iso="langIso"
                    :user-token="userToken"
                    :action-banners="actionBanners"
                    :curation-banner="curationContext.banner"
                    class="col-12 col-md-8 col-lg-9"
                />
                <algolia-search-no-results category class="col-12 col-md-8 col-lg-9"/>
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
import AlgoliaSearchResults from "./AlgoliaSearchResults";
import AlgoliaSearchNoResults from "./AlgoliaSearchNoResults";
import FilterPanelMobile from "./Partials/FilterPanelMobile";
import { AisConfigure, AisInstantSearch, AisRefinementList, AisSearchBox, } from "vue-instantsearch/vue3/es";
import {
    index, algoliaClient
} from "../../js/algoliaSettings";

import FilterPanel from "./Partials/FilterPanel";
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { fetchCurationContext, composeSearchFilters } from "../../js/curationRules";
import qs from "qs";

const normalizeFilter = (filter = {}) => {
    const normalized = {};

    for (const property in filter) {
        const item = filter[property];
        normalized[property] = Array.isArray(item) ? item : [item].filter(Boolean);
    }

    return normalized;
};

export default {
    components: {
        AisSearchBox,
        FilterPanel,
        FilterPanelMobile,
        AisInstantSearch,
        AisRefinementList,
        AisConfigure,
        AlgoliaSearchResults,
        AlgoliaSearchNoResults
    },
    props: {
        categoryFilters: {
            type: Array,
            required: true,
            default: () => []
        },
        categoryId: {
            type: Number,
            required: false,
            default: 0
        },
        langIso: {
            type: String,
            required: false,
            default: 'nl-NL',
        },
        actionBanners: {
            type: Array,
            required: false,
            default: () => [],
        },
        userPersonalisationIdentifier: {
            type: Number,
            required: false,
            default: null,
        }
    },
    computed: {
        searchFilters() {
            const baseFilter = this.categoryId ? `categories.id_category = ${this.categoryId}` : `id > 0`;
            return composeSearchFilters(baseFilter, this.curationContext);
        }
    },
    watch: {
        categoryId: {
            immediate: true,
            async handler(categoryId) {
                this.curationContext = await fetchCurationContext({ trigger: null, categoryId });
            }
        }
    },
    created() {
        if (document.getElementById("orders-button-bottom")) {
            document.getElementById("orders-button-bottom").classList.add('d-none');
        }

        if (document.getElementById("filters-button-bottom")) {
            document.getElementById("filters-button-bottom").classList.remove('d-none');
        }
    },
    data() {
        // Filters present on the URL when the page loads, kept around so they
        // survive being written back to the address bar even for attributes
        // that don't have a mounted refinement-list widget on this page.
        const initialRefinementList = normalizeFilter(
            qs.parse(window.location.search.slice(1)).filter
        );

        return {
            curationContext: { banner: null, hiddenIds: [], exclusiveIds: null },
            searchClient: algoliaClient(),
            index: index(),
            userToken: null,
            routing: {
                router: historyRouter({

                    createURL({ qsModule, routeState, location }) {

                        const queryParameters = {};

                        if (routeState.query) {
                            queryParameters.query = encodeURIComponent(routeState.query);
                        }
                        if (routeState.page !== 1) {
                            queryParameters.page = routeState.page;
                        }

                        if (routeState.refinementList) {
                            queryParameters.filter = routeState.refinementList;
                        }

                        const queryString = qsModule.stringify(queryParameters, {
                            addQueryPrefix: true,
                            arrayFormat: 'repeat'
                        });

                        return `${queryString}`;
                    },

                    parseURL({ qsModule, location }) {

                        const { query = '', page, filter = {} } = qsModule.parse(
                            location.search.slice(1)
                        );

                        return {
                            query: decodeURIComponent(query),
                            page,
                            refinementList: normalizeFilter(filter),
                        };
                    }
                }),
                stateMapping: {
                    stateToRoute(uiState) {
                        const indexUiState = uiState[index()] || {};

                        return {
                            query: indexUiState.query,
                            page: indexUiState.page,
                            refinementList: {
                                ...initialRefinementList,
                                ...indexUiState.refinementList,
                            },
                        };
                    },
                    routeToState(routeState) {
                        return {
                            [index()]: {
                                query: routeState.query,
                                page: routeState.page,
                                refinementList: routeState.refinementList
                            }
                        };
                    }
                },
            }
        };
    }
};
</script>
